import api from '../../../../api';

export const StepperSelector = {
  STEPPER: api.internals.ns.selector('stepper')
};
